export const Hyperlinks = () => {
  $(function () {
    const $elements = $("[data-hyperlinks-target]");

    $elements.each(function () {
      const target = $(this).data("hyperlinks-target");
      const $hyperlinks = $(this).find("a:not(.scroll-to)");

      $hyperlinks.each(function () {
        const $this = $(this);
        if (!$this.attr("target")) {
          $this.attr("target", target);
        }
        if ($this.attr("target") === "_blank" && !$this.attr("rel")) {
          $this.attr("rel", "noopener noreferrer");
        }
      });
    });
  });
};